import moment from "moment";
import { interval } from "rxjs";
import { ajax } from "rxjs/ajax";
import { delay, filter, first, mergeMap, retry } from "rxjs/operators";
import version from "./version";
import auth from "../store/modules/auth";
import { toObject } from "./languageContent";
import _ from "lodash";
import XLSX from "xlsx/xlsx";
import sanitizeHtml from "sanitize-html";
import store from "../store";

const parser = require("ua-parser-js");
export const getExtensionFromFileName = (filename) => {
    filename = filename || "";
    return filename.includes(".") ? filename.split(".").pop() : "file";
};

export const baseUrl = () => {
    if (document.currentScript) {
        let _documentUrl = document.currentScript.src.split("/");
        return _documentUrl[0] + "//" + _documentUrl[2] + "/";
    } else {
        return "/";
    }
};
/**
 *
 * @param key string veya value üreten bir fonksiyon olabilir
 * @param type alabilceği değerler= string(default) || number|| date
 * @param sortedInfo object {columnKey:String,order:(ascend|descend)} şuanki tablodaki sıralama bilgisi
 * @param keyName keyi eğer FN olarak verdiyseniz sıralama kıyaslancak key'i buraya giriniz.
 * @returns {{defaultSortOrder: string, sorter: (function(*=, *=): number)}}
 */
export const tableSorter = (key, type = "string", sortedInfo, keyName) => {
    const result = {
        sortOrder: sortedInfo
            ? sortedInfo.columnKey === (typeof key === "function" ? keyName : key) && sortedInfo.order
            : undefined,

        sorter: (a, b) => {
            const keyIsFunction = typeof key === "function";
            if (keyIsFunction) {
                a = key(a);
                b = key(b);
            } else {
                if (type === "number") {
                    a = _.get(a, key);
                    b = _.get(b, key);
                } else if (type === "array_len") {
                    a = Array.isArray(_.get(a, key)) ? _.get(a, key).length : 0;
                    b = Array.isArray(_.get(b, key)) ? _.get(b, key).length : 0;
                } else if (type === "date") {
                    a =
                        _.get(a, key) && moment(_.get(a, key)).toDate().getTime()
                            ? moment(_.get(a, key)).toDate().getTime()
                            : null;
                    b =
                        _.get(b, key) && moment(_.get(b, key)).toDate().getTime()
                            ? moment(_.get(b, key)).toDate().getTime()
                            : null;
                } else {
                    a = _.get(a, key) ? _.get(a, key).toString().trim().toLowerCase() : _.get(a, key);
                    b = _.get(b, key) ? _.get(b, key).toString().trim().toLowerCase() : _.get(b, key);
                }
            }
            return _.sortBy([a, b])[0] === a ? -1 : 1;
        },
    };
    if (!result.sortOrder) delete result.sortOrder;
    return result;
};

export const agentOS = parser(navigator.userAgent).os.name;
export const isMac = agentOS === "Mac OS";

const versionInfoRequest = () => ajax.getJSON(location.origin + "/static/version.json").pipe(delay(1000));

export const onNewVersionReceived = interval(60 * 1000)
    .pipe(
        mergeMap((_) => versionInfoRequest()),
        retry(),
        filter((remoteVersion) => version.versionStr !== remoteVersion.version),
        first()
    )
    .toPromise();

export const PRODUCTION = process.env.PRODUCTION === "true";
export const IS_DEV_ENVIRONMENT = process.env.ENVIRONMENT === "development";
export const IS_STAGE_ENVIRONMENT = process.env.ENVIRONMENT === "stage";
export const IS_PROD_ENVIRONMENT = process.env.ENVIRONMENT === "production";

export const SELF_SERVICE_DOMAIN = IS_DEV_ENVIRONMENT
    ? "local.supsis.live"
    : IS_STAGE_ENVIRONMENT
    ? "beta.supsis.live"
    : "supsis.live";

export const fakeConversation = () => ({
    active: true,
    chatBarOrder: 1,
    connectedDate: new Date().toISOString(),
    connectedUser: "5fc8af6effdadb0020624905",
    createdDate: new Date().toISOString(),
    email: "tanitim@supsis.com",
    fullname: "Supsis Tanıtım",
    username: "supsisTanitim",
    users: [auth.state.user],
    visitor: {
        browser: "Chrome 87.0.4280 ",
        country: "N/A",
        ipAddress: "172.18.0.1",
        os: " Mac OS X 11.1.0",
        _id: "5fc8af6effdadb0020624905",
    },
    messages: [
        {
            conversation: "5fc8af6effdadb0020624905",
            createdDate: "2020-12-25T13:13:49.090Z",
            description: "Aramıza hoşgeldiniz",
            messageType: "system",
            systemMessageType: "welcome-message",
            updatedBy: null,
            __v: 0,
            _id: "5fc8af6effdadb0020624905",
        },
    ],
    isOnline: true,
    unread: 0,
    languageCode: "tr",
});

export const fakeContents = () =>
    [
        {
            _id: "5d33901fd4357c001deb2511",
            updatedAt: "2019-07-20T22:07:50.405Z",
            createdAt: "2019-07-20T22:05:19.580Z",
            isActive: true,
            number: "0",
            name: "ödeme",
            letter: "test 123",
            content: "test 123",
            __v: 0,
            isDeleted: false,
            updatedBy: null,
            createdBy: null,
            type: "TITLE",
            languageContent: [
                { name: "ödeme", content: "test 123", languageCode: "tr" },
                {
                    name: "paymenty",
                    content: "test 123",
                    languageCode: "en",
                },
                {
                    name: "оплата",
                    content: "test 123",
                    languageCode: "ru",
                },
                {
                    name: "Zahlung",
                    content: "test 123",
                    languageCode: "de",
                },
                {
                    name: "paiement",
                    content: "test 123",
                    languageCode: "fr",
                },
                {
                    name: "pagamento",
                    content: "test 123",
                    languageCode: "es",
                },
                {
                    name: "قسط",
                    content: "اختبار 123",
                    languageCode: "ar",
                },
                {
                    name: "pagamento",
                    content: "test 123",
                    languageCode: "it",
                },
            ],
            parentId: null,
        },
        {
            _id: "5fc8b31e10d1980019dceb7a",
            updatedAt: "2020-12-03T09:42:54.595Z",
            createdAt: "2020-12-03T09:42:54.595Z",
            letter: "sip",
            number: "s",
            isActive: true,
            isDeleted: false,
            updatedBy: null,
            createdBy: { _id: "5fc8af6effdadb0020624902" },
            type: "TAB",
            languageContent: [
                {
                    name: "sipariş no",
                    content: "sipariş numaranız nedir",
                    languageCode: "tr",
                },
                {
                    name: "order no",
                    content: "order no yazın",
                    languageCode: "en",
                },
                {
                    name: "оплата",
                    content: "какой у вас номер заказа",
                    languageCode: "ru",
                },
                {
                    name: "Zahlung",
                    content: "Was ist Ihre Bestellnummer",
                    languageCode: "de",
                },
                {
                    name: "paiement",
                    content: "quel est votre numéro de commande",
                    languageCode: "fr",
                },
                {
                    name: "pagamento",
                    content: "qual è il tuo numero d'ordine",
                    languageCode: "es",
                },
                {
                    name: "قسط",
                    content: "ما هو رقم طلبك",
                    languageCode: "ar",
                },
                {
                    name: "pagamento",
                    content: "qual è il tuo numero d'ordine",
                    languageCode: "it",
                },
            ],
            parentId: "5d33901fd4357c001deb2511",
            __v: 0,
        },
        {
            _id: "5fc8b31e10d1980019dceb7b",
            updatedAt: "2020-12-03T09:42:54.595Z",
            createdAt: "2020-12-03T09:42:54.595Z",
            letter: "m",
            number: "",
            isActive: true,
            isDeleted: false,
            updatedBy: null,
            createdBy: { _id: "5fc8af6effdadb0020624902" },
            type: "ALT",
            languageContent: [
                {
                    name: "sipariş no",
                    content: "sipariş numaranız nedir",
                    languageCode: "tr",
                },
                {
                    name: "order no",
                    content: "order no yazın",
                    languageCode: "en",
                },
                {
                    name: "оплата",
                    content: "какой у вас номер заказа",
                    languageCode: "ru",
                },
                {
                    name: "Zahlung",
                    content: "Was ist Ihre Bestellnummer",
                    languageCode: "de",
                },
                {
                    name: "paiement",
                    content: "quel est votre numéro de commande",
                    languageCode: "fr",
                },
                {
                    name: "pagamento",
                    content: "qual è il tuo numero d'ordine",
                    languageCode: "es",
                },
                {
                    name: "قسط",
                    content: "ما هو رقم طلبك",
                    languageCode: "ar",
                },
                {
                    name: "pagamento",
                    content: "qual è il tuo numero d'ordine",
                    languageCode: "it",
                },
            ],
            parentId: "5d33901fd4357c001deb2511",
            __v: 0,
        },
    ].map((x) => toObject(x));

export const capitalize = (str = "") => {
    str = str.trim().toLowerCase();
    return str
        .split(" ")
        .map((x) => x.trim())
        .filter((x) => x.length > 0)
        .map((x) => `${x[0].toUpperCase()}${x.substring(1)}`)
        .map((x) => x.trim())
        .join(" ");
};

export const validateEmail = (email) => {
    const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
};

export const WHATSAPP_COMMANDS = {
    GET_CONTACTS: `whatsapp get-contacts`,
};

export const copyText2Clipboard = (str) => {
    const el = document.createElement("textarea");
    el.value = str;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    try {
        navigator.clipboard.writeText(str);
    } catch (e) {
        console.error(e);
    }
};
export const copyImage2Clipboard = async (imageUrl) => {
    const img = new Image();
    const c = document.createElement("canvas");
    const ctx = c.getContext("2d");
    function setCanvasImage(path, func) {
        img.crossOrigin = "anonymous";
        img.onload = function () {
            c.width = this.naturalWidth;
            c.height = this.naturalHeight;
            ctx.drawImage(this, 0, 0);
            c.toBlob((blob) => {
                func(blob);
            }, "image/png");
        };
        img.src = path;
    }
    imageUrl = imageUrl.replace("static.supsis.live", "s3.eu-central-1.amazonaws.com/static.supsis.live");
    setCanvasImage(imageUrl, (imgBlob) => {
        navigator.clipboard
            .write([new ClipboardItem({ "image/png": imgBlob })])
            .then((e) => {
                console.log("Image copied to clipboard");
            })
            .catch((e) => {
                console.log(e);
            });
    });

    // try {
    //     imageUrl = imageUrl.replace("static.supsis.live", "s3.eu-central-1.amazonaws.com/static.supsis.live");
    //     const blob = await fetch(imageUrl, {}).then((r) => r.blob());
    //     console.log("blob", blob);
    //     const item = new ClipboardItem({ [blob.type]: blob });
    //     await navigator.clipboard.write([item]);
    // } catch (e) {
    //     console.error(e);
    // }
};
export const getTextFromClipboard = () => {
    try {
        const el = document.createElement("textarea");
        document.body.appendChild(el);
        el.select();
        document.execCommand("paste");
        const result = el.value;
        document.body.removeChild(el);
        return result;
    } catch (e) {
        return null;
    }
};

export const exportToCSV = (csv, filename) => {
    const replacer = (key, value) => (value === null ? "" : value); // specify how you want to handle null values here
    const header = Object.keys(csv[0]);
    let csvContent = csv.map((row) => header.map((fieldName) => JSON.stringify(row[fieldName], replacer)).join(","));
    csvContent.unshift(header.join(","));
    csvContent = csvContent.join("\r\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
export const expertToExcel = (data, filename, sheetName = "Report Data") => {
    console.log("expertToExcel", {
        data,
        filename,
        sheetName,
    });
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    XLSX.writeFile(workbook, filename);
};

export const FeatureItems = {
    CHATBOT: "chatbot", // maxSessionCount, storyCountLimit, integrationCount, chatbotVersionHistory
    AGENT: "agent", // freeAgentCount, agentCount, agentPerPrice,
    TRIGGERS: "triggers", // maxTriggerCount
    SUPPORT: "support", // support, 7-24-support, software-support, dedicatedCustomerSupport
    SYSTEM: "system", // chatAndNotification, chatballonCustomization, removeSupsisLogo, databaseConnection, singlePanelAccess, ticketSystem
    ARCHIVE: "archive", // maxChatArchiveTime, chatArchiveTime,
    REPORT: "report", // basic-report, detail-report, visitorTracking
    CHAT: "chat", // autoTranslation, voiceCalling, videoCalling,
    TEAM_CHAT: "team_chat", //private, maxTeamChatArchiveTime, teamChatArchiveTime, team...
    WHATSAPP: "whatsapp", //brodcastPerMessage, bulkMessageSending, messageUnregisteredNumbers, personalizedBroadcastMessage, chatbotButtonActivity
    MAIL: "mail",
    SMS: "sms",
};

export const SanitizeHtml = (val, clearHtml) => {
    if (clearHtml) {
        const el = document.createElement("div");
        el.innerHTML = val;
        val = el.innerText;
    } else {
        val = sanitizeHtml(val, {
            allowVulnerableTags: true,
            allowedTags: [
                "span",
                "strong",
                "a",
                "b",
                "i",
                "s",
                "em",
                "u",
                "p",
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "style",
                "pre",
                "ol",
                "ul",
                "li",
                "table",
                "tbody",
                "tr",
                "td",
                "br",
            ],
            allowedAttributes: {
                "*": ["class", "style", "width", "height"],
                a: ["href", "target"],
            },
            allowedStyles: {
                "*": {
                    color: [/^#(0x)?[0-9a-f]+$/i, /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/],
                    background: [
                        /^#(0x)?[0-9a-f]+$/i,
                        /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/,
                        /(a-z|A-Z)/,
                    ],
                    "background-color": [
                        /^#(0x)?[0-9a-f]+$/i,
                        /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/,
                        /(a-z|A-Z)/,
                    ],
                    "text-align": [/^left$/, /^right$/, /^center$/],
                    "font-size": [/^\d+(?:px|em|%)$/],
                    "letter-spacing": [/^\d+(?:px|em|%)$/],
                    "font-family": [/(a-z|A-Z)/],
                },
            },
        });
    }
    return val;
};

export const isMaskContactInfo = (key) => {
    const maskedFields = ["email", "phone", "whatsappNumber"];
    const settings = store.state.setting.settings;
    const isRoot = _.get(store.state.auth, "user.role.isRoot", false);
    return !isRoot && settings && settings.maskSensitiveInfo && maskedFields.includes(key);
};

export const maskContactInfo = (val, maxLength = 5) => {
    if (!val) return "";
    const settings = store.state.setting.settings;
    const maskSensitiveInfo = settings && settings.maskSensitiveInfo;
    const isRoot = _.get(store.state.auth, "user.role.isRoot", false);
    return !isRoot && maskSensitiveInfo ? val.slice(0, maxLength).padEnd(val.length, "*") : val;
};

/** Ayarlardaki "hassas iletişim bilgisini maskele" (maskSensitiveInfo) açık ve kullanıcı root değilse true — maskContactInfo ile aynı önkoşul */
export const isMaskSensitiveInfoSettingEnabled = () => {
    const settings = store.state.setting.settings;
    const maskSensitiveInfo = settings && settings.maskSensitiveInfo;
    const isRoot = _.get(store.state.auth, "user.role.isRoot", false);
    return !isRoot && maskSensitiveInfo;
};

const normalizeRefVisitorForActivityMask = (refVisitor) => {
    if (!refVisitor) return null;
    if (Array.isArray(refVisitor) && refVisitor.length > 0) return refVisitor[0];
    return refVisitor;
};

/** İsim alanı e-posta veya telefon benzeri mi (activity bildirimleri için) */
export const visitorDisplayNameLooksLikeSensitiveContact = (val) => {
    if (val === null || val === undefined) return false;
    const str = String(val).trim();
    if (!str) return false;
    if (/\S+@\S+\.\S+/.test(str)) return true;
    const digits = str.replace(/\D/g, "");
    if (digits.length < 5) return false;
    if (/^[\d\s\+\-\(\)\.]+$/.test(str)) return true;
    if (/\d{5,}/.test(str)) return true;
    return false;
};

/**
 * maskSensitiveInfo açıkken: visitor adı telefon/e-posta ile aynıysa veya metin hassas iletişim gibi görünüyorsa maskele.
 * Ayar kapalıyken veya root kullanıcıda maske uygulanmaz (isMaskSensitiveInfoSettingEnabled).
 */
export const maskVisitorDisplayNameIfNeeded = (val, refVisitor) => {
    if (val === null || val === undefined) return val;
    const str = String(val);
    if (!isMaskSensitiveInfoSettingEnabled()) return val;

    const visitor = normalizeRefVisitorForActivityMask(refVisitor);
    if (visitor) {
        if (str === visitor.phone || str === visitor.whatsappNumber || str === visitor.email) {
            return maskContactInfo(str);
        }
    }
    if (visitorDisplayNameLooksLikeSensitiveContact(str)) {
        return maskContactInfo(str);
    }
    return val;
};
